import { showUnauthorisedAccount } from './show-not-authorised/show-not-authorised.js'

/**
 * Ensure
 *  (1) the account is public or
 *  (2) the user
 *    (2.1) is logged in and
 *    (2.2) has access to the account
 * @param {Object} [params]
 * @param {Object} [params.browserAppAccount]
 * @param {Object} [params.browserAppUser]
 * @param {Boolean} [params.allowAnonymous] true to allow public accounts
 * @param {Boolean} [params.allowPublic] true to allow public accounts
 * @param {Boolean} [params.allowNoAccount] true to allow page for logged in user, without a specific account?
 * @returns false if restriction not successful: we want false to move forward
 */
export function checkPageRestriction (params) {
  const {
    browserAppAccount,
    browserAppUser,
    allowAnonymous = false,
    allowPublic = false,
    allowNoAccount = false
  } = params

  const appAccount = browserAppAccount?.data?.appAccount

  // User should be logged in except if allowAnonymous is true
  if (allowAnonymous && appAccount) return true
  if (allowAnonymous && (!appAccount && allowNoAccount)) return true

  // User should be logged in
  if (!browserAppUser?.isLoggedIn()) return showUnauthorisedAccount()

  if (allowNoAccount) return true

  if (allowPublic && appAccount?.isPublic) return true

  // The server needs to apply the restriction; if data reached frontend, the user is authorised
  if (appAccount) return true

  showUnauthorisedAccount()
  return false
}
